import React from 'react'
import { IMAGES_BASE_PATH } from '../../config/constants';
import Statistics from './Components/Statistics';
interface AboutProps {
    landingPageData: any; // Replace `any` with the correct type if available
    eventData: any;        // Replace `any` with the correct type if available
  }
const About:React.FC <AboutProps>= ({landingPageData,eventData}) => {
    console.log("landingPageData?.data",landingPageData);
    const welcomeNoteSection = landingPageData?.mid_section.find(
        (section: any) => section.key === 'welcome_note'
      );
      
      // Then access its properties
      const welcomeHeading = welcomeNoteSection?.welcome_note_heading;
      const welcomeText = welcomeNoteSection?.welcome_note_text;
      const welcomeImage = welcomeNoteSection?.welcome_note_image?.key
      ? IMAGES_BASE_PATH + welcomeNoteSection.welcome_note_image.key
      : "images/about.png";
      return (
        <>
<div className="single-section about-area silver-bg" id="about">
    <div className="container">
        <div className="row">
            <div className="col-lg-5 col-sm-12">
            <div className="custom-image-wrapper">

                <img  src={welcomeImage} className="custom-img" alt="" height="397px"
  width="440px"/>
            </div>
                       
            </div>
            <div className="col-lg-7 col-sm-12">
                {/* <!--section heading--> */}
                <div className="section-heading">
                    <h2 className="section-title" style={{
   '--before-bg': eventData.primary_color
  }}> {welcomeHeading}</h2>

                    <p className="section-description">{welcomeText}</p>

                

                </div>
                {/* <!--section heading ends!--> */}

 <Statistics landingPageData={landingPageData} eventData={eventData} />


            </div>

        </div>



    </div>
     
</div>
  
    </>
  )
}

export default About